export default {
    date: "{{date, DD-MM-YYYY}}",
};
